import timelineTemplate1Url from '../timeline-template1.html';

export const timelineEditComponent = {
	template:
		`<timeline-main 
			details="$ctrl.details" 
			on-cancel="$ctrl.onCancel()" 
			is-added = "false"
			on-submit="$ctrl._onSubmit(details)" 
			disable-buttons="$ctrl.disableButtons"
			 >
		</timeline-main>`,

	bindings: {
		details: '<',
	},

	controller: class TimelineEditComponent {
		constructor($state, $stateParams, $timeout, $anchorScroll, TimelineService, LocationService, toastr, ModalService, CompareObjectService, DateService) {
			'ngInject';
			this.$state = $state;
			this.$stateParams = $stateParams;
			this.$timeout = $timeout;
			this.$anchorScroll = $anchorScroll;
			this.TimelineService = TimelineService;
			this.locationService = LocationService;
			this.toastr = toastr;
			this.modalService = ModalService;
			this.CompareObjectService = CompareObjectService;
			this.dateService = DateService;
		}
		$onInit() {
			this.disableButtons = false;
			this.savedData = angular.copy(this.details);
		}


		_onSubmit(details) {
			let updateDetails = {
				showInWebsite: details.isEnable,
				displayName: details.title,
				bodyColor: details.bodyColor,
				borderColor: details.borderColor,
				url: details.taskLink,
				taskList: details.taskList.map((item, index) => {
					let data = {
						status: item.status,
						task: item.description,
						sortOrder: index + 1
					}
					if (item.id) {
						data.taskId = item.id
					}
					return data
				})
			}

			if (this.$state.router.globals.current.parentState === "spouseChecklist") {
				updateDetails.isSpouseChecklist = true
			}

			this.TimelineService.editTimeline(updateDetails, this.$stateParams.id)
				.then(({ details }) => {
					this.toastr.success("Timeline Updated successfully");
					if (this.$state.router.globals.current.parentState === "spouseChecklist") {
						this.$state.go('spouseChecklistDetails', {
							id: details.timelineId
						});
					} else {
						this.$state.go('timelineDetails', {
							id: details.timelineId
						});
					}

				}).catch((errmsg) => {
					this.toastr.error(errmsg);
					this.disableButtons = false;
				});
		}

		onCancel() {
			const isUpdated = this.CompareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, false);
			if (isUpdated) {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},
					buttons: [{
						name: 'cancel'
					}, {
						name: 'ok',
						isPrimary: true,
						action: () => {
							this.$state.go(this.$state.router.globals.current.parentState);
						}
					}]
				});
			} else {
				this.$state.go(this.$state.router.globals.current.parentState);
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline-edit/timeline-edit.component.js